/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_Missing_FeaturesInputs */

const en_settings_cancel_reason_missing_features = /** @type {(inputs: Settings_Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features don't fit my needs`)
};

const id_settings_cancel_reason_missing_features = /** @type {(inputs: Settings_Cancel_Reason_Missing_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiturnya belum sesuai kebutuhan`)
};

/**
* | output |
* | --- |
* | "Features don't fit my needs" |
*
* @param {Settings_Cancel_Reason_Missing_FeaturesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_missing_features = /** @type {((inputs?: Settings_Cancel_Reason_Missing_FeaturesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_Missing_FeaturesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_missing_features(inputs)
	return en_settings_cancel_reason_missing_features(inputs)
});